import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { LinkBehaviour } from "../../../../../../components/LinkBehaviour";
import { RedirectionLinkCard } from "../RedirectionLinkCard/RedirectionLinkCard";
import styles from "./ShopTeaser.module.scss";
export const ShopTeaser = ({ title, isTitleHidden, src, href, bottomText, isLoyalty, logoSrc, isBottomGradient, isTopGradient, }) => {
    const dispatchGTMEvent = () => {
        dispatchTrackingEvent(TrackingEvents.TrackingMenuNavigationListClick);
    };
    const isTitleShown = title && !isTitleHidden;
    return (_jsxs("div", { children: [_jsx("div", { className: classNames(styles.wrapper, {
                    [styles.withTopGradient]: isTopGradient && !isBottomGradient,
                    [styles.withBottomGradient]: isBottomGradient && !isTopGradient,
                    [styles.bothGradients]: isTopGradient && isBottomGradient,
                    [styles.withBottomText]: bottomText,
                    [styles.bottomTextOnlyPlacement]: !isTitleShown && bottomText,
                }), style: {
                    "--bg-image-url": `url(${src})`,
                }, "data-testid": "shop-container", children: _jsxs(LinkBehaviour, { onClick: dispatchGTMEvent, href: href, children: [isTitleShown && _jsx("span", { children: title }), logoSrc && (_jsx("div", { className: styles.logo, style: {
                                "--logo-image-url": `url(${logoSrc})`,
                            }, "data-testid": "shop-teaser-logo" })), _jsx("span", { children: bottomText })] }) }), _jsx(RedirectionLinkCard, { className: styles.mobileVariant, link: href, title: title, variant: isLoyalty ? "ploomClub" : "withImage", image: src })] }));
};
//# sourceMappingURL=ShopTeaser.js.map